const PRICE_SCALE = 100;

const toFiniteNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

const toMinorUnits = (value) => Math.round(toFiniteNumber(value) * PRICE_SCALE);

export const extractApiCollection = (response, key) => {
  const candidates = [
    response?.data?.data?.[key],
    response?.data?.[key],
    response?.[key],
  ];

  return candidates.find(Array.isArray) || [];
};

export const getNetPrice = (item) => {
  if (!item) return 0;

  const price = toMinorUnits(item.price);
  const discount = toMinorUnits(item.discount);
  return Math.max(price - discount, 0) / PRICE_SCALE;
};

export const getPlanUserNetPrice = (plan) => {
  if (!plan) return 0;

  return getNetPrice({
    price: plan.user_price,
    discount: plan.user_discount,
  });
};

export const uniqueAddonsById = (addons = []) => {
  const seen = new Set();

  return addons.filter((addon) => {
    if (addon?.id === undefined || addon?.id === null) return false;

    const key = String(addon.id);
    if (seen.has(key)) return false;

    seen.add(key);
    return true;
  });
};

export const expandAddonDependencies = (addons = [], allAddons = []) => {
  const addonById = new Map(
    allAddons
      .filter((addon) => addon?.id !== undefined && addon?.id !== null)
      .map((addon) => [String(addon.id), addon]),
  );
  const resolved = [];
  const seen = new Set();

  const visit = (candidate) => {
    if (candidate?.id === undefined || candidate?.id === null) return;

    const key = String(candidate.id);
    if (seen.has(key)) return;

    const addon = addonById.get(key) || candidate;
    seen.add(key);
    resolved.push(addon);

    const dependencies = Array.isArray(addon.dependent_addons)
      ? addon.dependent_addons
      : [];
    dependencies.forEach(visit);
  };

  addons.forEach(visit);
  return resolved;
};

export const sumAddonPrices = (addons = []) => {
  const totalInMinorUnits = uniqueAddonsById(addons).reduce(
    (total, addon) => total + toMinorUnits(getNetPrice(addon)),
    0,
  );

  return totalInMinorUnits / PRICE_SCALE;
};

export const calculatePricingTotal = ({ plan, usersCount, addons = [] }) => {
  if (!plan) return 0;

  const normalizedUsers = Math.max(Math.floor(toFiniteNumber(usersCount)), 0);
  const basePlanPrice = toMinorUnits(getNetPrice(plan));
  const usersPrice =
    normalizedUsers * toMinorUnits(getPlanUserNetPrice(plan));
  const addonsPrice = toMinorUnits(sumAddonPrices(addons));

  return (basePlanPrice + usersPrice + addonsPrice) / PRICE_SCALE;
};
